import { render, staticRenderFns } from "./rebate.vue?vue&type=template&id=be3212dc&scoped=true"
import script from "./rebate.vue?vue&type=script&lang=js"
export * from "./rebate.vue?vue&type=script&lang=js"
import style0 from "./rebate.vue?vue&type=style&index=0&id=be3212dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3212dc",
  null
  
)

export default component.exports